import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Spanish translations
const esTranslations = {
    common: {
        loading: 'Cargando...',
        save: 'Guardar',
        cancel: 'Cancelar',
        delete: 'Eliminar',
        edit: 'Editar',
        create: 'Crear',
        search: 'Buscar',
        filter: 'Filtrar',
        export: 'Exportar',
        download: 'Descargar',
        downloadedAs: '{{name}} descargado como {{format}}',
        downloadFailed: 'Error al descargar',
        upload: 'Subir',
        submit: 'Enviar',
        back: 'Volver',
        next: 'Siguiente',
        previous: 'Anterior',
        yes: 'Sí',
        no: 'No',
        actions: 'Acciones',
        status: 'Estado',
        date: 'Fecha',
        name: 'Nombre',
        description: 'Descripción',
        area: 'Área',
        hectares: 'hectáreas',
        refresh: 'Actualizar',
        retry: 'Reintentar',
    },
    nav: {
        dashboard: 'Panel de Control',
        polygons: 'Polígonos',
        analysis: 'Análisis',
        analytics: 'Analítica',
        reports: 'Reportes',
        settings: 'Configuración',
        logout: 'Cerrar Sesión',
    },
    analytics: {
        title: 'Analítica',
        subtitle: 'Inteligencia de portafolio sobre todos tus lotes en el tiempo',
        allCommodities: 'Todos los commodities',
        allCountries: 'Todos los países',
        allStatus: 'Todos los estados',
        trend: 'Deforestación en el tiempo',
        byCompliance: 'Por cumplimiento',
        donutHint: 'Distribución de lotes por estado de cumplimiento',
        riskMap: 'Mapa de riesgo',
        topRisk: 'Lotes de mayor riesgo',
        breakdown: 'Desglose',
        scatter: 'Área vs. deforestación',
        lots: 'Lotes analizados',
    },
    dashboard: {
        title: 'Panel de Control',
        welcome: 'Bienvenido a Hit the Land',
        subtitle: 'Inteligencia de Riesgo EUDR y Soporte de Decisiones',
        totalPolygons: 'Polígonos Totales',
        totalArea: 'Área Total',
        analysisCompleted: 'Análisis Completados',
        complianceRate: 'Tasa de Cumplimiento',
        recentActivity: 'Actividad Reciente',
        quickActions: 'Acciones Rápidas',
        errorLoading: 'Error al cargar estadísticas.',
        complianceSummary: 'Resumen de Cumplimiento',
        noAnalysisYet: 'Sin análisis completados aún.',
        pdfWithTraceability: 'PDF con trazabilidad',
        noRecentActivity: 'Sin actividad reciente.',
        uploadFirstPolygon: 'Subir primer polígono',
    },
    polygons: {
        title: 'Gestión de Polígonos',
        subtitle: 'Administra tus lotes y fincas para monitoreo EUDR',
        addPolygon: 'Agregar Polígono',
        uploadGeoJSON: 'Subir GeoJSON',
        drawOnMap: 'Dibujar en Mapa',
        producer: 'Productor',
        commodity: 'Commodity',
        region: 'Región',
        country: 'País',
        noPolygons: 'No hay polígonos registrados',
        uploadHint: 'Arrastra un archivo GeoJSON aquí o haz clic para seleccionar',
        portfolioCount: '{{count}} polígono(s) en portafolio',
        backToPortfolio: 'Volver al portafolio',
    },
    workspace: {
        actions: 'Acciones',
        validate: 'Validar',
        validateDescription: 'Verificaciones de topología y geometría',
        analyze: 'Analizar',
        analyzing: 'Analizando...',
        analyzeDescription: 'Detección de deforestación',
        analysisInProgress: 'Análisis en proceso',
        reports: 'Reportes',
        reportsDescription: 'Ver reportes generados',
        secondaryActions: 'Acciones secundarias',
        editGeometry: 'Editar Geometría',
        viewDetails: 'Ver Detalles',
        deletePolygon: 'Eliminar Polígono',
    },
    analysis: {
        title: 'Análisis EUDR',
        subtitle: 'Seguimiento de análisis de compliance y generación de reportes',
        newAnalysis: 'Nuevo Análisis',
        baselineYear: 'Año Base',
        monitoringYear: 'Año de Monitoreo',
        maxCloudCover: 'Máxima Cobertura de Nubes',
        status: {
            pending: 'En cola',
            queued: 'En cola',
            processing: 'Procesando',
            completed: 'Completado',
            failed: 'Fallido',
            cancelled: 'Cancelado',
        },
        cancelledByUser: 'Cancelado por el usuario',
        results: {
            totalArea: 'Área Total',
            deforestedArea: 'Área Deforestada',
            percentage: 'Porcentaje',
            ndviChange: 'Cambio NDVI',
        },
        complianceTitle: 'Análisis de Cumplimiento EUDR',
        complianceDescription: 'Los análisis detectan cambios de cobertura forestal entre el año base y el año de monitoreo usando datos satelitales de alta resolución (Sentinel-2 + Sentinel-1). Al completarse, generan un reporte PDF de screening de riesgo si se solicita.',
        estimatedTime: 'Tiempo estimado',
        dataSource: 'Fuente de datos',
        resolution: 'Resolución',
        indices: 'Índices',
        jobsTitle: 'Trabajos de Análisis',
        errorLoadingJobs: 'Error al cargar trabajos de análisis',
        analysisFailed: 'El análisis falló',
        failedHint: 'Puede deberse a una sobrecarga temporal o a que el análisis excedió el tiempo máximo. Reintenta; si persiste, reduce el área del lote.',
        reportDownloaded: 'Reporte descargado exitosamente',
        reportDownloadError: 'Error al descargar reporte',
        noJobs: 'No hay análisis iniciados',
        started: 'Iniciado',
        report: 'Reporte',
        generated: 'Generado',
        viewResults: 'Ver Resultados',
        downloadReport: 'Descargar Reporte',
        startAnalysis: 'Iniciar Análisis EUDR',
        howItWorks: '¿Cómo funciona el análisis?',
        howItWorksDescription: 'El análisis compara dos períodos que tú eliges: un año de referencia "antes" (año base) y un año actual "después" (año de monitoreo). Se analizan todas las imágenes satelitales de ambos años para detectar cambios en la cobertura forestal.',
        howItWorksExample: 'Si eliges 2020 → 2024, el sistema comparará cómo estaba el bosque en 2020 vs cómo está en 2024 para identificar deforestación.',
        selectPeriod: 'Selecciona el Período a Comparar',
        baselineLabel: 'Año de Inicio (Estado "Antes")',
        monitoringLabel: 'Año Final (Estado "Después")',
        baselineHint: 'Año de referencia histórica',
        monitoringHint: 'Año actual a evaluar (hasta {{maxYear}})',
        comparisonNote: 'Se compararán: Todas las imágenes satelitales de {{baseline}} vs {{monitoring}}. Puedes elegir cualquier combinación de años entre 2017 y {{maxYear}}.',
        generatePdfAuto: 'Generar reporte PDF automáticamente',
        reportLanguage: 'Idioma del Reporte',
        processingTitle: 'Sobre el procesamiento',
        processingWhatHappens: 'Adquirimos y procesamos todas las escenas satelitales disponibles (Sentinel-2 óptico + Sentinel-1 radar) de ambos años, detectamos cambios de cobertura forestal a nivel de parcela y, si lo solicitaste, compilamos el reporte de screening.',
        processingTime: 'Tiempo estimado: 10–20 minutos por análisis.',
        processingFactors: 'Puede variar según la nubosidad, el tamaño del polígono y la cola de procesamiento.',
        processingBackground: 'El análisis se ejecuta en segundo plano: puedes cerrar esta ventana y seguir el progreso en la lista de análisis.',
        submitting: 'Iniciando...',
        startButton: 'Iniciar Análisis',
        yearValidation: {
            baselineBeforeMonitoring: 'El año base debe ser anterior al año de monitoreo',
            baselineRange: 'El año base debe estar entre 2017 y {{maxYear}} (datos confiables)',
            monitoringRange: 'El año de monitoreo debe estar entre 2017 y {{maxYear}}',
        },
        analysisStarted: 'Análisis iniciado exitosamente',
        analysisError: 'Error al iniciar análisis',
        validationErrors: 'Errores de validación',
        confidence: {
            high: 'Confianza Alta',
            medium: 'Confianza Media',
            low: 'Confianza Baja',
        },
    },
    reports: {
        title: 'Reportes de Screening EUDR',
        subtitle: 'Reportes de screening EUDR con evidencia satelital',
        generate: 'Generar Reporte',
        downloadPDF: 'Descargar PDF',
        certificate: 'Referencia',
        language: 'Idioma',
        backToList: 'Volver a lista de reportes',
        searchPlaceholder: 'referencias',
        loadingReports: 'Cargando reportes...',
        loadError: 'Error al Cargar Reportes',
        errorLoading: 'Error al cargar reportes',
        noReports: 'No hay reportes disponibles',
        autoGenerated: 'Los reportes se generan automáticamente al completar análisis de polígonos.',
        fileSize: 'Tamaño',
        viewAnalysis: 'Ver Análisis',
        downloadError: 'Error al descargar el reporte. Por favor intente nuevamente.',
    },
    manage: {
        label: 'Etiqueta',
        labelPlaceholder: 'Ej: Lote prioritario Q3',
        notes: 'Notas',
        notesPlaceholder: 'Notas internas (opcional)',
        sortBy: 'Ordenar por',
        sortNewest: 'Más recientes',
        sortOldest: 'Más antiguos',
        sortName: 'Nombre (A-Z)',
        sortStatus: 'Estado',
        sortArea: 'Área',
        sortSize: 'Tamaño',
        showArchived: 'Ver archivados',
        showActive: 'Ver activos',
        archive: 'Archivar',
        unarchive: 'Restaurar',
        archived: 'Archivado',
        editJob: 'Editar trabajo',
        editReport: 'Editar reporte',
        archiveConfirm: '¿Archivar este elemento? Podrás restaurarlo desde "Ver archivados".',
        unarchiveConfirm: '¿Restaurar este elemento a la lista activa?',
        cancel: 'Cancelar análisis',
        cancelConfirm: '¿Cancelar este análisis? Solo se pueden cancelar los que aún no han empezado a procesarse.',
        cancelledSuccess: 'Análisis cancelado',
        cancelAll: 'Cancelar en cola',
        cancelAllConfirm: '¿Cancelar TODOS los análisis en cola (los que aún no han empezado)? Los que ya están procesándose seguirán.',
        cancelAllSuccess: '{{count}} análisis en cola cancelados',
        retry: 'Reintentar',
        retrySuccess: 'Análisis reintentado',
        saved: 'Cambios guardados',
        archivedSuccess: 'Elemento archivado',
        restoredSuccess: 'Elemento restaurado',
        actionError: 'No se pudo completar la acción',
        noResults: 'Sin resultados para tu búsqueda',
        noArchived: 'No hay elementos archivados',
        searchJobs: 'Buscar por polígono, etiqueta, estado...',
        searchReports: 'Buscar por título, certificado, etiqueta...',
    },
    legal: {
        terms: 'Términos del Servicio',
        privacy: 'Política de Privacidad',
        lastUpdated: 'Última actualización',
        agreePrefix: 'Al crear una cuenta, aceptas nuestros',
        and: 'y',
    },
    compliance: {
        compliant: 'Cumple',
        nonCompliant: 'No Cumple',
        inconclusive: 'Inconcluso',
        pending: 'Pendiente',
        riskLow: 'Riesgo Bajo',
        riskMedium: 'Riesgo Medio',
        riskHigh: 'Riesgo Alto',
    },
    commodities: {
        cocoa: 'Cacao',
        timber: 'Madera',
        soy: 'Soja',
        palm_oil: 'Aceite de Palma',
        coffee: 'Café',
        rubber: 'Caucho',
        cattle: 'Ganado',
    },
    auth: {
        login: 'Iniciar Sesión',
        register: 'Registrarse',
        email: 'Correo Electrónico',
        password: 'Contraseña',
        confirmPassword: 'Confirmar Contraseña',
        fullName: 'Nombre Completo',
        organization: 'Organización',
        forgotPassword: '¿Olvidaste tu contraseña?',
        noAccount: '¿No tienes cuenta?',
        hasAccount: '¿Ya tienes cuenta?',
        invalidCredentials: 'Email o contraseña incorrectos.',
    },
    errors: {
        required: 'Este campo es requerido',
        invalidEmail: 'Email inválido',
        passwordMin: 'La contraseña debe tener al menos 8 caracteres',
        serverError: 'Error del servidor. Intenta de nuevo.',
        networkError: 'No se pudo conectar con el servidor. Revisa tu conexión e intenta de nuevo.',
        unauthorized: 'No autorizado. Por favor inicia sesión.',
    },
    analysisResults: {
        title: 'Resultados del Análisis',
        tabs: {
            overview: 'Resumen',
            indices: 'Índices',
            sensitivity: 'Sensibilidad',
            quality: 'Calidad',
            imagery: 'Imágenes',
            scenes: 'Reporte de Escenas',
        },
        sceneReport: {
            title: 'Reporte de Aceptación de Escenas',
            description: 'Reporte detallado de cada escena Sentinel-2 evaluada durante el análisis. Muestra qué escenas fueron aceptadas o rechazadas según la clasificación SCL (Scene Classification Layer) de nubes/sombras sobre el área del polígono.',
            notAvailable: 'Reporte de escenas no disponible. Ejecute un nuevo análisis para generar datos SCL por escena.',
            acceptedBaseline: 'Aceptadas (Línea Base)',
            rejectedBaseline: 'Rechazadas (Línea Base)',
            acceptedMonitoring: 'Aceptadas (Monitoreo)',
            rejectedMonitoring: 'Rechazadas (Monitoreo)',
            sclLegend: 'Leyenda de Clases SCL',
            sclNote: 'Verde = clases de píxeles aceptadas | Rojo = rechazadas (enmascaradas como NaN). Umbral de nubes por polígono:',
            interpretation: 'Las escenas se rechazan cuando >70% de los píxeles sobre el polígono están enmascarados por nubes/sombras. Se mantienen al menos 3 escenas por período (las más claras). La distribución SCL muestra el desglose de clasificación a nivel de píxel para cada escena antes del enmascaramiento.',
        },
        sarHybrid: 'SAR Híbrido',
        adaptiveWindow: 'Ventana Adaptativa',
        compliantEudr: 'CUMPLE CON EUDR',
        nonCompliantEudr: 'NO CUMPLE CON EUDR',
        riskLevel: 'Nivel de riesgo',
        analysisConfidence: 'Confianza del análisis',
        confidenceHigh: 'ALTA',
        confidenceMedium: 'MEDIA',
        confidenceLow: 'BAJA',
        changeAnalysisResults: 'Resultados del Análisis de Cambios',
        totalAnalyzedArea: 'Área Total Analizada',
        deforestedArea: 'Área Deforestada',
        lossPercentage: 'Porcentaje de Pérdida',
        ofAnalyzedArea: 'del área analizada',
        detectionMethodology: 'Metodología de Detección',
        method: 'Método',
        hybridOpticalSar: 'Híbrido óptico + SAR',
        ensembleDualIndex: 'Ensemble dual-index + z-score',
        indicesLabel: 'Índices',
        significance: 'Significancia',
        falsePositive: 'Falso Positivo',
        sarHybridCoverage: 'Cobertura Híbrida SAR',
        opticalOnly: 'Solo óptico',
        sarOnly: 'Solo SAR',
        both: 'Ambos',
        deforestationPatches: 'Parches de Deforestación Detectados ({{count}})',
        patch: 'Parche',
        pixels: 'Píxeles',
        areaHa: 'Área (ha)',
        confidence: 'Confianza',
        ndviTitle: 'NDVI — Índice de Vegetación Normalizado',
        ndviDescription: 'Mide la densidad de vegetación verde. Valores altos (0.6–1.0) = bosque denso, medios (0.2–0.6) = vegetación moderada, bajos (<0.2) = suelo desnudo/agua.',
        baselinePeriodMedian: 'Mediana del período base',
        currentPeriodMedian: 'Mediana del período actual',
        ndviChange: 'Cambio NDVI',
        threshold: 'Umbral',
        nbrTitle: 'NBR — Índice de Quema Normalizado',
        nbrDescription: 'Sensible a cambios en humedad y estructura del dosel forestal. Usa la banda SWIR (1610 nm). Complementa al NDVI para reducir falsos positivos.',
        nbrChange: 'Cambio NBR',
        dualIndexTitle: 'Detección Dual-Index Ensemble — ¿Por qué dos índices?',
        dualIndexDescription: 'El NDVI es sensible a cambios en verdor pero puede dar falsos positivos por variaciones estacionales o atmosféricas. El NBR usa la banda infrarroja de onda corta (SWIR) que penetra mejor la atmósfera y detecta cambios estructurales en el dosel. Un pixel solo se marca como deforestación si ambos índices muestran pérdida estadísticamente significativa (z > {{zScore}}, {{significance}}). La probabilidad conjunta de falso positivo se reduce a ~0.25% por pixel al requerir acuerdo de ambos índices independientes.',
        sensitivityTitle: 'Análisis de Sensibilidad',
        sensitivityDescription: 'Misma detección ejecutada a tres niveles de estrictez para evaluar la robustez del resultado. Un resultado consistente entre niveles indica alta confiabilidad.',
        sensitivityConservative: 'Conservador',
        sensitivityStandard: 'Estándar (Usado)',
        sensitivitySensitive: 'Sensible',
        ofArea: 'del área',
        sensitivityNotAvailable: 'Análisis de sensibilidad no disponible.',
        interpretation: 'Interpretación',
        sensitivityInterpretation: 'Si los tres niveles muestran resultados similares, la detección es robusta. Si el nivel sensible detecta mucho más que el conservador, los cambios detectados están cerca del límite de detección y merecen verificación adicional.',
        confidenceWeightedAverage: 'Promedio ponderado de factores independientes de calidad de datos.',
        confidenceFactors: 'Factores de Confianza (Desglose)',
        obsDensityBaseline: 'Densidad obs. baseline',
        obsDensityMonitor: 'Densidad obs. monitor',
        spatialOverlap: 'Overlap espacial',
        minPeriodCoverage: 'Cobertura mín. período',
        sceneCount: 'Cantidad de escenas',
        sarGapFill: 'SAR gap-fill',
        pixelQuality: 'Calidad de pixel (impacto nubes)',
        pixelQualityDist: 'Distribución de Calidad por Pixel',
        pixelQualityNote: 'La calidad refleja la densidad de observaciones libres de nubes. Pixeles de baja calidad requieren evidencia más fuerte para detección de deforestación (umbrales z-score adaptativos).',
        satelliteDataCoverage: 'Cobertura de Datos Satelitales',
        overlapBothPeriods: 'Overlap (ambos períodos)',
        sarCoverage: 'Cobertura SAR (Sentinel-1 Radar)',
        pxCoveredByRadarOnly: 'px cubiertos solo por radar',
        warning: 'Advertencia',
        analysisParameters: 'Parámetros del Análisis',
        paramDataSource: 'Fuente de datos',
        paramResolution: 'Resolución',
        paramBaselinePeriod: 'Período baseline',
        paramMonitorPeriod: 'Período monitor',
        paramWindowType: 'Tipo de ventana',
        paramOpticalScenes: 'Escenas ópticas',
        paramSarScenes: 'Escenas SAR',
        paramMethod: 'Método',
        paramSignificanceLevel: 'Nivel de significancia',
        paramFalsePositiveProb: 'Prob. falso positivo',
        paramNdviThreshold: 'Umbral NDVI',
        paramNbrThreshold: 'Umbral NBR',
        paramCloudCoverMax: 'Cloud cover max',
        paramMinObsPerPixel: 'Obs. mínimas/pixel',
        paramMinObsValue: '2 escenas (adaptativo, prefiere 3+)',
        paramMinPatch: 'Parche mínimo (MMU)',
        paramProjection: 'Proyección',
        changeMap: 'Mapa de Cambios (NDVI)',
        deforestedAreas: 'Áreas Deforestadas',
        observationDensity: 'Densidad de Observaciones (Calidad de Datos)',
        observationDensityDescription: 'Número de escenas válidas (sin nubes) por pixel. Más observaciones = mediana más robusta. Áreas con pocas observaciones (<3) se excluyen del análisis.',
        sarVhBackscatter: 'SAR VH Retrodispersión (dB)',
        sarChangeDetection: 'Detección de Cambio SAR',
        hybridCoverageLabel: 'Cobertura Híbrida (Óptico + SAR)',
        hybridCoverageDescription: 'Verde = cobertura óptica. Azul = cobertura SAR (huecos de nubes rellenados con radar). Amarillo = ambas fuentes disponibles.',
        imageryDescriptionSar: 'Imágenes procesadas desde Sentinel-2 L2A (óptico) + Sentinel-1 SAR (radar). Verde = vegetación densa, rojo = pérdida. SAR rellena huecos de nubes para cobertura 100%.',
        imageryDescriptionOptical: 'Imágenes procesadas desde Sentinel-2 L2A. Verde = vegetación densa, rojo = pérdida. Blanco = sin datos suficientes (nubes persistentes).',
        noImageryAvailable: 'No hay imágenes disponibles para este análisis.',
        imageryLoading: 'Cargando imágenes satelitales…',
        galleryLoading: 'Cargando composites Sentinel-2…',
        close: 'Cerrar',
        scenes: 'escenas',
    },
    technicalReport: {
        title: 'Reporte de Cumplimiento EUDR',
        regulationReference: 'Regulación de la Unión Europea sobre Deforestación (UE) 2023/1115',
        noAssociatedAnalysis: 'No hay análisis asociado a este reporte',
        errorLoadingData: 'Error al cargar datos del reporte',
        errorLoadingReport: 'Error al Cargar Reporte',
        loadingReport: 'Cargando reporte técnico...',
        unnamed: 'Sin nombre',
        tabs: {
            imagery: 'Imágenes Satelitales',
            statistics: 'Análisis Estadístico',
            eudr: 'Cumplimiento EUDR',
            parameters: 'Parámetros de Análisis',
            metadata: 'Metadatos',
        },
        certifiedEntity: 'Entidad Certificada',
        polygonReference: 'Referencia del Polígono',
        analysisPeriod: 'Período de Análisis',
        compliant: 'CUMPLE',
        nonCompliant: 'NO CUMPLE',
        deforestationFreeVerified: 'Verificado Libre de Deforestación',
        deforestationDetected: 'Deforestación Detectada',
        forestLoss: 'Pérdida Forestal',
        ofArea: 'del área',
        riskLevel: 'Nivel de Riesgo',
        classification: 'Clasificación',
        certificateId: 'ID de Certificado',
        validUntil: 'Válido Hasta',
        imagery: {
            ndviAnalysis: 'Análisis NDVI Sentinel-2',
            ndviAnalysisDescription: 'Comparación temporal entre períodos de referencia y monitoreo. El análisis NDVI (Índice de Vegetación de Diferencia Normalizada) destaca áreas de cambio en la vegetación.',
            ndviBaseline: 'NDVI Año Base ({{year}})',
            ndviBaselineDescription: 'Índice de vegetación del período de referencia. Verde oscuro = bosque denso.',
            ndviMonitoring: 'NDVI Año Monitoreo ({{year}})',
            ndviMonitoringDescription: 'Índice de vegetación del período actual. Comparar con año base para detectar cambios.',
            changeMapTitle: 'Mapa de Cambios (NDVI Delta)',
            changeMapDescription: 'Diferencia de NDVI entre períodos. Rojo = pérdida de vegetación, Verde = ganancia.',
            deforestationDetected: 'Áreas Deforestadas Detectadas',
            deforestationMaskDescription: 'Zonas rojas = deforestación detectada sobre fondo de NDVI base.',
            totalDeforestedArea: 'Área total deforestada',
            areaPercentage: 'Porcentaje del área',
            changeDetection: 'Detección de Cambios',
            alerts: 'Alertas',
            patches: 'parches',
            largestPatch: 'Parche Más Grande',
            totalLoss: 'Pérdida Total',
            ndviScale: 'Escala de Interpretación NDVI',
            denseForest: 'Bosque Denso',
            vegetation: 'Vegetación',
            sparseVeg: 'Veg. Dispersa',
            bareSoil: 'Suelo Desnudo',
        },
        statistics: {
            title: 'Evaluación Cuantitativa y Métricas de Cumplimiento',
            description: 'Mediciones detalladas y análisis de umbrales de cumplimiento basados en el procesamiento de datos espectrales Sentinel-2.',
            complianceThresholdAnalysis: 'Análisis de Umbrales de Cumplimiento',
            eudrLimit: 'Límite EUDR',
            detectedLoss: 'Pérdida detectada',
            limit: 'Límite',
            loss: 'Pérdida',
            compliantZone: 'Zona Conforme',
            nonCompliantZone: 'Zona No Conforme',
            is: 'está',
            below: 'por debajo',
            above: 'por encima',
            theLimit: 'del límite de',
            metric: 'Métrica',
            hectares: 'Hectáreas',
            squareMeters: 'Metros Cuadrados',
            percentage: 'Porcentaje',
            totalAnalyzedArea: 'Área Total Analizada',
            stableForestCover: 'Cobertura Forestal Estable',
            detectedForestLoss: 'Pérdida Forestal Detectada',
            complianceThreshold: 'Umbral de Cumplimiento',
            reference: 'Referencia',
            marginToThreshold: 'Margen al Umbral',
            buffer: 'Buffer',
            methodologyNotes: 'Notas Metodológicas',
            methodologyDescription: 'Análisis realizado usando la comparación temporal del Índice de Vegetación de Diferencia Normalizada (NDVI). Los valores NDVI se calculan a partir de las bandas espectrales Sentinel-2 B4 (Rojo) y B8 (NIR) usando la fórmula: NDVI = (NIR - Red) / (NIR + Red). Los cambios negativos significativos en el NDVI entre períodos indican pérdida potencial de vegetación. Se aplica un umbral de cambio NDVI de -0.15 combinado con un tamaño mínimo de cluster de 0.1 ha para filtrar ruido e identificar eventos genuinos de pérdida forestal.',
            toleranceThreshold: 'El umbral de tolerancia de 0.5 hectáreas tiene en cuenta: (i) la incertidumbre inherente de clasificación, (ii) la dinámica forestal natural, y (iii) los límites de precisión geométrica del sensor a 10m de resolución.',
        },
        eudr: {
            title: 'Requisitos de Cumplimiento EUDR',
            description: 'Validación detallada basada en la Regulación UE 2023/1115 y las definiciones forestales de la FAO',
            validationNotAvailable: 'Datos de validación EUDR no disponibles',
            validationNotAvailableDescription: 'Los datos de validación geométrica y umbrales FAO no pudieron ser cargados para este reporte.',
            baselineState: 'Estado Base (31 de Diciembre, 2020)',
            classification: 'Clasificación',
            lockedDescription: 'BLOQUEADO: Este polígono fue clasificado como BOSQUE en la fecha de corte EUDR. Cualquier conversión a uso agrícola está PROHIBIDA bajo la Regulación UE 2023/1115.',
            safeDescription: 'SEGURO: Tierra agrícola preexistente. El uso agrícola continuado está permitido con la documentación adecuada.',
            forestCover: 'Cobertura Forestal',
            confidence: 'Confianza',
            referenceDate: 'Fecha de Referencia',
            dataSource: 'Fuente de Datos',
            faoThresholdsTitle: 'Umbrales de Definición Forestal FAO',
            faoThresholdsDescription: 'Los tres criterios deben cumplirse simultáneamente para la clasificación forestal',
            treeCoverDensity: 'Densidad de Cobertura Arbórea',
            minimumArea: 'Área Mínima',
            treeHeight: 'Altura de Árboles',
            threshold: 'Umbral',
            current: 'Actual',
            estimated: 'Estimado',
            approxPixels: '≈50 píxeles',
            pass: 'PASA',
            fail: 'FALLA',
            edgeEffectsCorrection: 'Corrección de Efectos de Borde',
            edgeEffectsDescription: 'Buffer negativo aplicado para evitar falsos positivos por imprecisiones GPS y disputas de límites con vecinos',
            originalArea: 'Área Original',
            coreArea: 'Área Central',
            buffer: 'Buffer',
            edgePercentage: 'Porcentaje de Borde',
            baselineLogicTitle: 'Lógica de Línea Base EUDR (31 Dic, 2020)',
            forestLogic: 'El polígono está permanentemente bloqueado. Cualquier cambio futuro a agricultura/pastoreo se considera deforestación ilegal bajo la Regulación UE 2023/1115.',
            agricultureLogic: 'El polígono es seguro para uso agrícola continuado, siempre que exista documentación legal de tenencia de tierra.',
            edgeEffectsRationale: 'Justificación de Efectos de Borde',
            edgeEffectsRationaleDescription: 'La precisión GPS es típicamente ±5-10 metros. Si un polígono se superpone con el bosque de un vecino y este deforesta, el análisis satelital marcará incorrectamente este polígono. Un buffer negativo (encogiéndose hacia adentro 5-10m) crea una "zona central segura" que analiza solo el interior definitivo, previniendo disputas de límites.',
            heightLimitationTitle: 'Limitación de Medición de Altura',
            heightLimitationDescription: 'Los satélites ópticos (Sentinel-2) no pueden medir la altura directamente. Las estimaciones de altura usan datos auxiliares de GEDI (LiDAR de NASA) o análisis de textura SAR de Sentinel-1. Para verificaciones de cumplimiento críticas, se recomienda la verificación en campo con mediciones de terreno.',
        },
        parameters: {
            title: 'Configuración Técnica y Fuentes de Datos',
            description: 'Especificación completa de los parámetros de análisis y fuentes de datos satelitales utilizados en esta evaluación de cumplimiento.',
            satellitePlatform: 'Plataforma Satelital',
            platform: 'Plataforma',
            spatialResolution: 'Resolución Espacial',
            spectralBands: 'Bandas Espectrales Utilizadas',
            cloudCoverFilter: 'Filtro de Cobertura de Nubes',
            temporalAnalysis: 'Análisis Temporal',
            baselinePeriod: 'Período Base',
            monitoringPeriod: 'Período de Monitoreo',
            analysisMethod: 'Método de Análisis',
            ndviThresholds: 'Umbrales NDVI',
            forestNdviThreshold: 'Umbral NDVI Forestal',
            deforestationThreshold: 'Umbral de Deforestación',
            complianceParameters: 'Parámetros de Cumplimiento',
            thresholdLimit: 'Límite de Umbral',
            minimumPatchSize: 'Tamaño Mínimo de Parche',
        },
        metadata: {
            title: 'Metadatos del Documento y Verificación',
            description: 'Metadatos completos para verificación del documento y propósitos de auditoría.',
            documentHash: 'Hash del Documento (SHA-256)',
            generationTimestamp: 'Fecha y Hora de Generación',
            issuingAuthority: 'Autoridad Emisora',
            certificationDate: 'Fecha de Certificación',
            authorizedSignatory: 'Firmante Autorizado',
            automatedAnalysisSystem: 'Sistema de Análisis Automatizado v2.0',
            reportVersion: 'Versión del Reporte',
            legalDisclaimer: 'Aviso Legal',
            disclaimerText1: 'Este reporte se genera basado en análisis automatizado de imágenes satelitales usando datos de Sentinel-2 proporcionados por el Programa Copernicus de la Agencia Espacial Europea (ESA). Aunque se ha hecho todo el esfuerzo para garantizar la precisión, este documento se proporciona solo con fines informativos y de apoyo a la debida diligencia.',
            disclaimerText2: 'Esta certificación no reemplaza las declaraciones regulatorias obligatorias, las auditorías de campo ni las certificaciones gubernamentales oficiales. La organización emisora no acepta responsabilidad por decisiones tomadas basándose únicamente en este documento. Se aconseja a los usuarios realizar verificaciones independientes y consultar con profesionales calificados para asuntos de cumplimiento regulatorio.',
        },
    },
    validation: {
        title: 'Validación de Cumplimiento EUDR',
        description: 'Validación técnica basada en la Regulación UE 2023/1115 y las definiciones forestales de la FAO',
        errorValidating: 'Error al validar polígono',
        validatingPolygon: 'Validando polígono...',
        validationError: 'Error de Validación',
        checksPassed: 'verificaciones pasadas',
        tabs: {
            topology: 'Topología',
            geometry: 'Geometría',
            baseline: 'Estado Base',
            thresholds: 'Umbrales FAO',
            edge: 'Efectos de Borde',
        },
        checks: {
            topologyValidation: 'Validación de Topología',
            topologyPass: 'Sin auto-intersecciones, cierre correcto',
            topologyFail: 'La geometría tiene problemas de topología',
            wgs84Compliance: 'Cumplimiento WGS84',
            wgs84Pass: 'Sistema de Referencia de Coordenadas validado',
            wgs84Fail: 'Usando {{crs}} en lugar de WGS84',
            fourHectareRule: 'Regla de 4 Hectáreas',
            fourHectarePass: 'Polígono obligatorio (>4ha)',
            fourHectareFail: 'Punto permitido pero polígono recomendado',
            baselineState: 'Estado Base (31 Dic, 2020)',
            classifiedAs: 'Clasificado como {{classification}}',
            faoTreeCoverDensity: 'Densidad de Cobertura Arbórea FAO',
            threshold: 'umbral',
        },
        topology: {
            title: 'Validación de Topología',
            description: 'Asegura que la geometría del polígono cumple con los estándares GIS para análisis espacial',
            selfIntersection: 'Auto-Intersección',
            noSelfIntersection: 'El polígono no se cruza a sí mismo',
            closure: 'Cierre',
            closureDescription: 'El primer y último punto son idénticos',
            vertexCount: 'Cantidad de Vértices',
            vertexCountDescription: 'Vértices originales que definen la forma del polígono',
            simplifiedVertices: 'Vértices Simplificados',
            simplifiedDescription: 'Optimizado para eficiencia de API (<5m pérdida de precisión)',
            precisionLoss: 'Pérdida de Precisión',
            precisionLossDescription: 'La simplificación geométrica resultó en {{meters}} metros de desplazamiento máximo. Esto está bien dentro del umbral aceptable (<5m) para análisis Sentinel-2 a resolución de 10 metros.',
        },
        geometry: {
            title: 'Información de Geometría',
            description: 'Referencia espacial y detalles de medición',
            crs: 'Sistema de Referencia de Coordenadas',
            tracesCompatible: 'Compatible con el sistema EU TRACES',
        },
        baseline: {
            title: 'Estado Base (31 de Diciembre, 2020)',
            description: 'La clasificación histórica de uso de tierra determina los requisitos de cumplimiento EUDR',
            estimatedTitle: 'Datos Base Estimados',
            estimatedDescription: 'Los datos base son estimados usando un modelo de screening basado en biomas. La integración de línea base verificada por satélite está en progreso.',
            classification: 'Clasificación',
            lockedMessage: 'BLOQUEADO: Cualquier conversión a agricultura está prohibida bajo EUDR',
            safeMessage: 'SEGURO: Tierra agrícola preexistente (sin riesgo de deforestación)',
            forestCover: 'Cobertura Forestal',
            confidence: 'Confianza',
            referenceDate: 'Fecha de Referencia',
            dataSource: 'Fuente de Datos',
            logicTitle: 'Lógica de Línea Base EUDR',
            logicForest: 'Si State_Initial == FOREST → El polígono está permanentemente bloqueado. Cualquier cambio futuro a agricultura/pastoreo se considera deforestación ilegal.',
            logicAgriculture: 'Si State_Initial == AGRICULTURE/GRASSLAND → El polígono es seguro para uso agrícola continuado, siempre que exista documentación legal.',
        },
        thresholds: {
            title: 'Umbrales de Definición Forestal FAO',
            description: 'Tres criterios simultáneos deben cumplirse para la clasificación forestal',
            treeCoverDensity: 'Densidad de Cobertura Arbórea',
            minimumArea: 'Área Mínima',
            treeHeight: 'Altura de Árboles',
            threshold: 'Umbral',
            currentValue: 'Valor Actual',
            currentArea: 'Área Actual',
            estimatedHeight: 'Altura Estimada',
            approxPixels: '≈ 50 píxeles contiguos',
            compliant: 'Cumple',
            nonCompliant: 'No Cumple',
            heightLimitationTitle: 'Limitación de Medición de Altura',
            heightLimitationDescription: 'Los satélites ópticos (Sentinel-2) no pueden medir la altura directamente. Este sistema usa datos auxiliares de GEDI (Investigación de Dinámica de Ecosistemas Globales) LiDAR o análisis de textura SAR (Sentinel-1) para estimar la altura del dosel. Para validaciones críticas, se recomienda la verificación en campo.',
        },
        edge: {
            title: 'Corrección de Efectos de Borde',
            description: 'Análisis de buffer para evitar falsos positivos por errores de límites con vecinos',
            recommended: 'Recomendado: Modo de Análisis Central',
            originalArea: 'Área Original',
            coreArea: 'Área Central (Después del Buffer)',
            bufferDistance: 'Distancia del Buffer',
            edgePercentage: 'Porcentaje de Borde',
            visualRepresentation: 'Representación Visual',
            loadingGeometry: 'Cargando geometría del polígono...',
            whyNegativeBuffer: '¿Por qué Buffer Negativo?',
            whyNegativeBufferDescription: 'La precisión GPS es típicamente ±5-10 metros. Si su polígono se superpone 3 metros dentro del bosque de su vecino y este tala árboles, el satélite le alertará a USTED incorrectamente. Aplicar un buffer negativo (encogiendo el polígono hacia adentro 5-10m) crea una "zona central segura" que analiza solo el interior definitivo de su parcela, evitando disputas de límites.',
        },
    },
    errorBoundary: {
        title: 'Algo salió mal',
        subtitle: 'Ocurrió un error inesperado en la aplicación',
        errorLabel: 'Error',
        stackTrace: 'Stack Trace (clic para expandir)',
        reloadPage: 'Recargar Página',
        goBack: 'Volver Atrás',
        tip: 'Tip',
        tipText: 'Si este error persiste, intenta:',
        tipClearCache: 'Limpiar la caché del navegador',
        tipCheckConsole: 'Verificar la consola del navegador (F12) para más detalles',
        tipContactSupport: 'Contactar al soporte técnico si el problema continúa',
    },
};

// English translations
const enTranslations = {
    common: {
        loading: 'Loading...',
        save: 'Save',
        cancel: 'Cancel',
        delete: 'Delete',
        edit: 'Edit',
        create: 'Create',
        search: 'Search',
        filter: 'Filter',
        export: 'Export',
        download: 'Download',
        downloadedAs: '{{name}} downloaded as {{format}}',
        downloadFailed: 'Download failed',
        upload: 'Upload',
        submit: 'Submit',
        back: 'Back',
        next: 'Next',
        previous: 'Previous',
        yes: 'Yes',
        no: 'No',
        actions: 'Actions',
        status: 'Status',
        date: 'Date',
        name: 'Name',
        description: 'Description',
        area: 'Area',
        hectares: 'hectares',
        refresh: 'Refresh',
        retry: 'Retry',
    },
    nav: {
        dashboard: 'Dashboard',
        polygons: 'Polygons',
        analysis: 'Analysis',
        analytics: 'Analytics',
        reports: 'Reports',
        settings: 'Settings',
        logout: 'Logout',
    },
    analytics: {
        title: 'Analytics',
        subtitle: 'Portfolio intelligence across all your lots over time',
        allCommodities: 'All commodities',
        allCountries: 'All countries',
        allStatus: 'All statuses',
        trend: 'Deforestation over time',
        byCompliance: 'By compliance',
        donutHint: 'Lots by compliance status',
        riskMap: 'Risk map',
        topRisk: 'Highest-risk lots',
        breakdown: 'Breakdown',
        scatter: 'Area vs. deforestation',
        lots: 'Analyzed lots',
    },
    dashboard: {
        title: 'Dashboard',
        welcome: 'Welcome to Hit the Land',
        subtitle: 'EUDR Risk Intelligence & Decision Support',
        totalPolygons: 'Total Polygons',
        totalArea: 'Total Area',
        analysisCompleted: 'Completed Analyses',
        complianceRate: 'Compliance Rate',
        recentActivity: 'Recent Activity',
        quickActions: 'Quick Actions',
        errorLoading: 'Error loading statistics.',
        complianceSummary: 'Compliance Summary',
        noAnalysisYet: 'No completed analyses yet.',
        pdfWithTraceability: 'PDF with traceability',
        noRecentActivity: 'No recent activity.',
        uploadFirstPolygon: 'Upload first polygon',
    },
    polygons: {
        title: 'Polygon Management',
        subtitle: 'Manage your lots and farms for EUDR monitoring',
        addPolygon: 'Add Polygon',
        uploadGeoJSON: 'Upload GeoJSON',
        drawOnMap: 'Draw on Map',
        producer: 'Producer',
        commodity: 'Commodity',
        region: 'Region',
        country: 'Country',
        noPolygons: 'No polygons registered',
        uploadHint: 'Drag a GeoJSON file here or click to select',
        portfolioCount: '{{count}} polygon(s) in portfolio',
        backToPortfolio: 'Back to portfolio',
    },
    workspace: {
        actions: 'Actions',
        validate: 'Validate',
        validateDescription: 'Topology & geometry checks',
        analyze: 'Analyze',
        analyzing: 'Analyzing...',
        analyzeDescription: 'Deforestation detection',
        analysisInProgress: 'Analysis in progress',
        reports: 'Reports',
        reportsDescription: 'View generated reports',
        secondaryActions: 'Secondary actions',
        editGeometry: 'Edit Geometry',
        viewDetails: 'View Details',
        deletePolygon: 'Delete Polygon',
    },
    analysis: {
        title: 'EUDR Analysis',
        subtitle: 'Compliance analysis tracking and report generation',
        newAnalysis: 'New Analysis',
        baselineYear: 'Baseline Year',
        monitoringYear: 'Monitoring Year',
        maxCloudCover: 'Maximum Cloud Cover',
        status: {
            pending: 'Queued',
            queued: 'Queued',
            processing: 'Processing',
            completed: 'Completed',
            failed: 'Failed',
            cancelled: 'Cancelled',
        },
        cancelledByUser: 'Cancelled by user',
        results: {
            totalArea: 'Total Area',
            deforestedArea: 'Deforested Area',
            percentage: 'Percentage',
            ndviChange: 'NDVI Change',
        },
        complianceTitle: 'EUDR Compliance Analysis',
        complianceDescription: 'Analyses detect forest cover changes between the baseline and monitoring years using high-resolution satellite data (Sentinel-2 + Sentinel-1). Upon completion, they generate a PDF risk-screening report if requested.',
        estimatedTime: 'Estimated time',
        dataSource: 'Data source',
        resolution: 'Resolution',
        indices: 'Indices',
        jobsTitle: 'Analysis Jobs',
        errorLoadingJobs: 'Error loading analysis jobs',
        analysisFailed: 'Analysis failed',
        failedHint: 'This may be a temporary overload or the analysis exceeded the maximum time. Retry; if it persists, reduce the plot area.',
        reportDownloaded: 'Report downloaded successfully',
        reportDownloadError: 'Error downloading report',
        noJobs: 'No analyses started',
        started: 'Started',
        report: 'Report',
        generated: 'Generated',
        viewResults: 'View Results',
        downloadReport: 'Download Report',
        startAnalysis: 'Start EUDR Analysis',
        howItWorks: 'How does the analysis work?',
        howItWorksDescription: 'The analysis compares two periods you choose: a "before" reference year (baseline) and a current "after" year (monitoring). All satellite imagery from both years is analyzed to detect forest cover changes.',
        howItWorksExample: 'If you choose 2020 → 2024, the system will compare how the forest looked in 2020 vs 2024 to identify deforestation.',
        selectPeriod: 'Select Comparison Period',
        baselineLabel: 'Start Year ("Before" State)',
        monitoringLabel: 'End Year ("After" State)',
        baselineHint: 'Historical reference year',
        monitoringHint: 'Current year to evaluate (up to {{maxYear}})',
        comparisonNote: 'Will compare: All satellite imagery from {{baseline}} vs {{monitoring}}. You can choose any combination of years between 2017 and {{maxYear}}.',
        generatePdfAuto: 'Generate PDF report automatically',
        reportLanguage: 'Report Language',
        processingTitle: 'About processing',
        processingWhatHappens: 'We acquire and process all available satellite scenes (Sentinel-2 optical + Sentinel-1 radar) from both years, detect plot-level forest-cover change and, if requested, compile the screening report.',
        processingTime: 'Estimated time: 10–20 minutes per analysis.',
        processingFactors: 'It may vary with cloud cover, polygon size and the processing queue.',
        processingBackground: 'The analysis runs in the background: you can close this window and track progress in the analysis list.',
        submitting: 'Starting...',
        startButton: 'Start Analysis',
        yearValidation: {
            baselineBeforeMonitoring: 'Baseline year must be before monitoring year',
            baselineRange: 'Baseline year must be between 2017 and {{maxYear}} (reliable data)',
            monitoringRange: 'Monitoring year must be between 2017 and {{maxYear}}',
        },
        analysisStarted: 'Analysis started successfully',
        analysisError: 'Error starting analysis',
        validationErrors: 'Validation errors',
        confidence: {
            high: 'High Confidence',
            medium: 'Medium Confidence',
            low: 'Low Confidence',
        },
    },
    reports: {
        title: 'EUDR Screening Reports',
        subtitle: 'EUDR screening reports with satellite evidence',
        generate: 'Generate Report',
        downloadPDF: 'Download PDF',
        certificate: 'Reference',
        language: 'Language',
        backToList: 'Back to reports list',
        searchPlaceholder: 'references',
        loadingReports: 'Loading reports...',
        loadError: 'Error Loading Reports',
        errorLoading: 'Error loading reports',
        noReports: 'No reports available',
        autoGenerated: 'Reports are generated automatically upon completing polygon analyses.',
        fileSize: 'Size',
        viewAnalysis: 'View Analysis',
        downloadError: 'Error downloading report. Please try again.',
    },
    manage: {
        label: 'Label',
        labelPlaceholder: 'e.g. Priority lot Q3',
        notes: 'Notes',
        notesPlaceholder: 'Internal notes (optional)',
        sortBy: 'Sort by',
        sortNewest: 'Newest first',
        sortOldest: 'Oldest first',
        sortName: 'Name (A-Z)',
        sortStatus: 'Status',
        sortArea: 'Area',
        sortSize: 'Size',
        showArchived: 'Show archived',
        showActive: 'Show active',
        archive: 'Archive',
        unarchive: 'Restore',
        archived: 'Archived',
        editJob: 'Edit job',
        editReport: 'Edit report',
        archiveConfirm: 'Archive this item? You can restore it later from "Show archived".',
        unarchiveConfirm: 'Restore this item to the active list?',
        cancel: 'Cancel analysis',
        cancelConfirm: 'Cancel this analysis? Only analyses that have not started processing yet can be cancelled.',
        cancelledSuccess: 'Analysis cancelled',
        cancelAll: 'Cancel queued',
        cancelAllConfirm: 'Cancel ALL queued analyses (those that have not started yet)? Analyses already processing will keep running.',
        cancelAllSuccess: '{{count}} queued analyses cancelled',
        retry: 'Retry',
        retrySuccess: 'Analysis retried',
        saved: 'Changes saved',
        archivedSuccess: 'Item archived',
        restoredSuccess: 'Item restored',
        actionError: 'Could not complete the action',
        noResults: 'No results for your search',
        noArchived: 'No archived items',
        searchJobs: 'Search by polygon, label, status...',
        searchReports: 'Search by title, certificate, label...',
    },
    legal: {
        terms: 'Terms of Service',
        privacy: 'Privacy Policy',
        lastUpdated: 'Last updated',
        agreePrefix: 'By creating an account, you agree to our',
        and: 'and',
    },
    compliance: {
        compliant: 'Compliant',
        nonCompliant: 'Non-Compliant',
        inconclusive: 'Inconclusive',
        pending: 'Pending',
        riskLow: 'Low Risk',
        riskMedium: 'Medium Risk',
        riskHigh: 'High Risk',
    },
    commodities: {
        cocoa: 'Cocoa',
        timber: 'Timber',
        soy: 'Soy',
        palm_oil: 'Palm Oil',
        coffee: 'Coffee',
        rubber: 'Rubber',
        cattle: 'Cattle',
    },
    auth: {
        login: 'Login',
        register: 'Register',
        email: 'Email',
        password: 'Password',
        confirmPassword: 'Confirm Password',
        fullName: 'Full Name',
        organization: 'Organization',
        forgotPassword: 'Forgot your password?',
        noAccount: "Don't have an account?",
        hasAccount: 'Already have an account?',
        invalidCredentials: 'Incorrect email or password.',
    },
    errors: {
        required: 'This field is required',
        invalidEmail: 'Invalid email',
        passwordMin: 'Password must be at least 8 characters',
        serverError: 'Server error. Please try again.',
        networkError: 'Could not reach the server. Check your connection and try again.',
        unauthorized: 'Unauthorized. Please login.',
    },
    analysisResults: {
        title: 'Analysis Results',
        tabs: {
            overview: 'Overview',
            indices: 'Indices',
            sensitivity: 'Sensitivity',
            quality: 'Quality',
            imagery: 'Imagery',
            scenes: 'Scene Report',
        },
        sceneReport: {
            title: 'Scene Acceptance Report',
            description: 'Detailed report of each Sentinel-2 scene evaluated during analysis. Shows which scenes were accepted or rejected based on SCL (Scene Classification Layer) cloud/shadow masking over the polygon area.',
            notAvailable: 'Scene report not available. Run a new analysis to generate scene-level SCL data.',
            acceptedBaseline: 'Accepted (Baseline)',
            rejectedBaseline: 'Rejected (Baseline)',
            acceptedMonitoring: 'Accepted (Monitoring)',
            rejectedMonitoring: 'Rejected (Monitoring)',
            sclLegend: 'SCL Class Legend',
            sclNote: 'Green = accepted pixel classes | Red = rejected (masked as NaN). Polygon cloud threshold:',
            interpretation: 'Scenes are rejected when >70% of pixels over the polygon are cloud/shadow-masked. At least 3 scenes per period are always kept (the clearest ones). The SCL distribution shows the pixel-level classification breakdown for each scene before masking.',
        },
        sarHybrid: 'SAR Hybrid',
        adaptiveWindow: 'Adaptive Window',
        compliantEudr: 'EUDR COMPLIANT',
        nonCompliantEudr: 'EUDR NON-COMPLIANT',
        riskLevel: 'Risk level',
        analysisConfidence: 'Analysis confidence',
        confidenceHigh: 'HIGH',
        confidenceMedium: 'MEDIUM',
        confidenceLow: 'LOW',
        changeAnalysisResults: 'Change Analysis Results',
        totalAnalyzedArea: 'Total Analyzed Area',
        deforestedArea: 'Deforested Area',
        lossPercentage: 'Loss Percentage',
        ofAnalyzedArea: 'of analyzed area',
        detectionMethodology: 'Detection Methodology',
        method: 'Method',
        hybridOpticalSar: 'Hybrid optical + SAR',
        ensembleDualIndex: 'Ensemble dual-index + z-score',
        indicesLabel: 'Indices',
        significance: 'Significance',
        falsePositive: 'False Positive',
        sarHybridCoverage: 'SAR Hybrid Coverage',
        opticalOnly: 'Optical only',
        sarOnly: 'SAR only',
        both: 'Both',
        deforestationPatches: 'Detected Deforestation Patches ({{count}})',
        patch: 'Patch',
        pixels: 'Pixels',
        areaHa: 'Area (ha)',
        confidence: 'Confidence',
        ndviTitle: 'NDVI — Normalized Difference Vegetation Index',
        ndviDescription: 'Measures green vegetation density. High values (0.6–1.0) = dense forest, medium (0.2–0.6) = moderate vegetation, low (<0.2) = bare soil/water.',
        baselinePeriodMedian: 'Baseline period median',
        currentPeriodMedian: 'Current period median',
        ndviChange: 'NDVI Change',
        threshold: 'Threshold',
        nbrTitle: 'NBR — Normalized Burn Ratio',
        nbrDescription: 'Sensitive to changes in moisture and forest canopy structure. Uses the SWIR band (1610 nm). Complements NDVI to reduce false positives.',
        nbrChange: 'NBR Change',
        dualIndexTitle: 'Dual-Index Ensemble Detection — Why two indices?',
        dualIndexDescription: 'NDVI is sensitive to greenness changes but can produce false positives from seasonal or atmospheric variations. NBR uses the shortwave infrared (SWIR) band which better penetrates the atmosphere and detects structural changes in the canopy. A pixel is only flagged as deforestation if both indices show statistically significant loss (z > {{zScore}}, {{significance}}). The joint false positive probability is reduced to ~0.25% per pixel by requiring agreement from both independent indices.',
        sensitivityTitle: 'Sensitivity Analysis',
        sensitivityDescription: 'Same detection run at three strictness levels to assess result robustness. A consistent result across levels indicates high reliability.',
        sensitivityConservative: 'Conservative',
        sensitivityStandard: 'Standard (Used)',
        sensitivitySensitive: 'Sensitive',
        ofArea: 'of area',
        sensitivityNotAvailable: 'Sensitivity analysis not available.',
        interpretation: 'Interpretation',
        sensitivityInterpretation: 'If all three levels show similar results, the detection is robust. If the sensitive level detects much more than the conservative, the detected changes are near the detection limit and deserve additional verification.',
        confidenceWeightedAverage: 'Weighted average of independent data quality factors.',
        confidenceFactors: 'Confidence Factors (Breakdown)',
        obsDensityBaseline: 'Obs. density baseline',
        obsDensityMonitor: 'Obs. density monitor',
        spatialOverlap: 'Spatial overlap',
        minPeriodCoverage: 'Min. period coverage',
        sceneCount: 'Scene count',
        sarGapFill: 'SAR gap-fill',
        pixelQuality: 'Pixel quality (cloud impact)',
        pixelQualityDist: 'Per-Pixel Quality Distribution',
        pixelQualityNote: 'Quality reflects cloud-free observation density. Low-quality pixels require stronger evidence for deforestation detection (adaptive z-score thresholds).',
        satelliteDataCoverage: 'Satellite Data Coverage',
        overlapBothPeriods: 'Overlap (both periods)',
        sarCoverage: 'SAR Coverage (Sentinel-1 Radar)',
        pxCoveredByRadarOnly: 'px covered by radar only',
        warning: 'Warning',
        analysisParameters: 'Analysis Parameters',
        paramDataSource: 'Data source',
        paramResolution: 'Resolution',
        paramBaselinePeriod: 'Baseline period',
        paramMonitorPeriod: 'Monitor period',
        paramWindowType: 'Window type',
        paramOpticalScenes: 'Optical scenes',
        paramSarScenes: 'SAR scenes',
        paramMethod: 'Method',
        paramSignificanceLevel: 'Significance level',
        paramFalsePositiveProb: 'False positive prob.',
        paramNdviThreshold: 'NDVI threshold',
        paramNbrThreshold: 'NBR threshold',
        paramCloudCoverMax: 'Cloud cover max',
        paramMinObsPerPixel: 'Min. obs./pixel',
        paramMinObsValue: '2 scenes (adaptive, prefers 3+)',
        paramMinPatch: 'Min. patch (MMU)',
        paramProjection: 'Projection',
        changeMap: 'Change Map (NDVI)',
        deforestedAreas: 'Deforested Areas',
        observationDensity: 'Observation Density (Data Quality)',
        observationDensityDescription: 'Number of valid (cloud-free) scenes per pixel. More observations = more robust median. Areas with few observations (<3) are excluded from analysis.',
        sarVhBackscatter: 'SAR VH Backscatter (dB)',
        sarChangeDetection: 'SAR Change Detection',
        hybridCoverageLabel: 'Hybrid Coverage (Optical + SAR)',
        hybridCoverageDescription: 'Green = optical coverage. Blue = SAR coverage (cloud gaps filled with radar). Yellow = both sources available.',
        imageryDescriptionSar: 'Images processed from Sentinel-2 L2A (optical) + Sentinel-1 SAR (radar). Green = dense vegetation, red = loss. SAR fills cloud gaps for 100% coverage.',
        imageryDescriptionOptical: 'Images processed from Sentinel-2 L2A. Green = dense vegetation, red = loss. White = insufficient data (persistent clouds).',
        noImageryAvailable: 'No imagery available for this analysis.',
        imageryLoading: 'Loading satellite imagery…',
        galleryLoading: 'Loading Sentinel-2 composites…',
        close: 'Close',
        scenes: 'scenes',
    },
    technicalReport: {
        title: 'EUDR Compliance Report',
        regulationReference: 'European Union Deforestation Regulation (EU) 2023/1115',
        noAssociatedAnalysis: 'No analysis associated with this report',
        errorLoadingData: 'Error loading report data',
        errorLoadingReport: 'Error Loading Report',
        loadingReport: 'Loading technical report...',
        unnamed: 'Unnamed',
        tabs: {
            imagery: 'Satellite Imagery',
            statistics: 'Statistical Analysis',
            eudr: 'EUDR Compliance',
            parameters: 'Analysis Parameters',
            metadata: 'Metadata',
        },
        certifiedEntity: 'Certified Entity',
        polygonReference: 'Polygon Reference',
        analysisPeriod: 'Analysis Period',
        compliant: 'COMPLIANT',
        nonCompliant: 'NON-COMPLIANT',
        deforestationFreeVerified: 'Deforestation-Free Verified',
        deforestationDetected: 'Deforestation Detected',
        forestLoss: 'Forest Loss',
        ofArea: 'of area',
        riskLevel: 'Risk Level',
        classification: 'Classification',
        certificateId: 'Certificate ID',
        validUntil: 'Valid Until',
        imagery: {
            ndviAnalysis: 'NDVI Sentinel-2 Analysis',
            ndviAnalysisDescription: 'Temporal comparison between reference and monitoring periods. NDVI (Normalized Difference Vegetation Index) analysis highlights areas of vegetation change.',
            ndviBaseline: 'NDVI Baseline Year ({{year}})',
            ndviBaselineDescription: 'Vegetation index for the reference period. Dark green = dense forest.',
            ndviMonitoring: 'NDVI Monitoring Year ({{year}})',
            ndviMonitoringDescription: 'Vegetation index for the current period. Compare with baseline year to detect changes.',
            changeMapTitle: 'Change Map (NDVI Delta)',
            changeMapDescription: 'NDVI difference between periods. Red = vegetation loss, Green = gain.',
            deforestationDetected: 'Detected Deforested Areas',
            deforestationMaskDescription: 'Red zones = detected deforestation overlaid on baseline NDVI.',
            totalDeforestedArea: 'Total deforested area',
            areaPercentage: 'Area percentage',
            changeDetection: 'Change Detection',
            alerts: 'Alerts',
            patches: 'patches',
            largestPatch: 'Largest Patch',
            totalLoss: 'Total Loss',
            ndviScale: 'NDVI Interpretation Scale',
            denseForest: 'Dense Forest',
            vegetation: 'Vegetation',
            sparseVeg: 'Sparse Veg.',
            bareSoil: 'Bare Soil',
        },
        statistics: {
            title: 'Quantitative Assessment and Compliance Metrics',
            description: 'Detailed measurements and compliance threshold analysis based on Sentinel-2 spectral data processing.',
            complianceThresholdAnalysis: 'Compliance Threshold Analysis',
            eudrLimit: 'EUDR Limit',
            detectedLoss: 'Detected loss',
            limit: 'Limit',
            loss: 'Loss',
            compliantZone: 'Compliant Zone',
            nonCompliantZone: 'Non-Compliant Zone',
            is: 'is',
            below: 'below',
            above: 'above',
            theLimit: 'the limit of',
            metric: 'Metric',
            hectares: 'Hectares',
            squareMeters: 'Square Meters',
            percentage: 'Percentage',
            totalAnalyzedArea: 'Total Analyzed Area',
            stableForestCover: 'Stable Forest Cover',
            detectedForestLoss: 'Detected Forest Loss',
            complianceThreshold: 'Compliance Threshold',
            reference: 'Reference',
            marginToThreshold: 'Margin to Threshold',
            buffer: 'Buffer',
            methodologyNotes: 'Methodology Notes',
            methodologyDescription: 'Analysis performed using Normalized Difference Vegetation Index (NDVI) temporal comparison. NDVI values are calculated from Sentinel-2 spectral bands B4 (Red) and B8 (NIR) using the formula: NDVI = (NIR - Red) / (NIR + Red). Significant negative NDVI changes between periods indicate potential vegetation loss. An NDVI change threshold of -0.15 combined with a minimum cluster size of 0.1 ha is applied to filter noise and identify genuine forest loss events.',
            toleranceThreshold: 'The 0.5 hectare tolerance threshold accounts for: (i) inherent classification uncertainty, (ii) natural forest dynamics, and (iii) sensor geometric precision limits at 10m resolution.',
        },
        eudr: {
            title: 'EUDR Compliance Requirements',
            description: 'Detailed validation based on EU Regulation 2023/1115 and FAO forest definitions',
            validationNotAvailable: 'EUDR validation data not available',
            validationNotAvailableDescription: 'Geometric validation and FAO threshold data could not be loaded for this report.',
            baselineState: 'Baseline State (December 31, 2020)',
            classification: 'Classification',
            lockedDescription: 'LOCKED: This polygon was classified as FOREST at the EUDR cutoff date. Any conversion to agricultural use is PROHIBITED under EU Regulation 2023/1115.',
            safeDescription: 'SAFE: Pre-existing agricultural land. Continued agricultural use is permitted with proper documentation.',
            forestCover: 'Forest Cover',
            confidence: 'Confidence',
            referenceDate: 'Reference Date',
            dataSource: 'Data Source',
            faoThresholdsTitle: 'FAO Forest Definition Thresholds',
            faoThresholdsDescription: 'All three criteria must be met simultaneously for forest classification',
            treeCoverDensity: 'Tree Cover Density',
            minimumArea: 'Minimum Area',
            treeHeight: 'Tree Height',
            threshold: 'Threshold',
            current: 'Current',
            estimated: 'Estimated',
            approxPixels: '≈50 pixels',
            pass: 'PASS',
            fail: 'FAIL',
            edgeEffectsCorrection: 'Edge Effects Correction',
            edgeEffectsDescription: 'Negative buffer applied to avoid false positives from GPS inaccuracies and boundary disputes with neighbors',
            originalArea: 'Original Area',
            coreArea: 'Core Area',
            buffer: 'Buffer',
            edgePercentage: 'Edge Percentage',
            baselineLogicTitle: 'EUDR Baseline Logic (Dec 31, 2020)',
            forestLogic: 'The polygon is permanently locked. Any future change to agriculture/grazing is considered illegal deforestation under EU Regulation 2023/1115.',
            agricultureLogic: 'The polygon is safe for continued agricultural use, provided legal land tenure documentation exists.',
            edgeEffectsRationale: 'Edge Effects Rationale',
            edgeEffectsRationaleDescription: 'GPS accuracy is typically ±5-10 meters. If a polygon overlaps with a neighbor\'s forest and the neighbor deforests, satellite analysis will incorrectly flag this polygon. A negative buffer (shrinking inward 5-10m) creates a "safe core zone" that analyzes only the definitive interior, preventing boundary disputes.',
            heightLimitationTitle: 'Height Measurement Limitation',
            heightLimitationDescription: 'Optical satellites (Sentinel-2) cannot measure height directly. Height estimates use auxiliary data from GEDI (NASA LiDAR) or Sentinel-1 SAR texture analysis. For critical compliance checks, field verification with ground measurements is recommended.',
        },
        parameters: {
            title: 'Technical Configuration and Data Sources',
            description: 'Complete specification of analysis parameters and satellite data sources used in this compliance assessment.',
            satellitePlatform: 'Satellite Platform',
            platform: 'Platform',
            spatialResolution: 'Spatial Resolution',
            spectralBands: 'Spectral Bands Used',
            cloudCoverFilter: 'Cloud Cover Filter',
            temporalAnalysis: 'Temporal Analysis',
            baselinePeriod: 'Baseline Period',
            monitoringPeriod: 'Monitoring Period',
            analysisMethod: 'Analysis Method',
            ndviThresholds: 'NDVI Thresholds',
            forestNdviThreshold: 'Forest NDVI Threshold',
            deforestationThreshold: 'Deforestation Threshold',
            complianceParameters: 'Compliance Parameters',
            thresholdLimit: 'Threshold Limit',
            minimumPatchSize: 'Minimum Patch Size',
        },
        metadata: {
            title: 'Document Metadata and Verification',
            description: 'Complete metadata for document verification and audit purposes.',
            documentHash: 'Document Hash (SHA-256)',
            generationTimestamp: 'Generation Timestamp',
            issuingAuthority: 'Issuing Authority',
            certificationDate: 'Certification Date',
            authorizedSignatory: 'Authorized Signatory',
            automatedAnalysisSystem: 'Automated Analysis System v2.0',
            reportVersion: 'Report Version',
            legalDisclaimer: 'Legal Disclaimer',
            disclaimerText1: 'This report is generated based on automated satellite imagery analysis using Sentinel-2 data provided by the European Space Agency (ESA) Copernicus Programme. While every effort has been made to ensure accuracy, this document is provided for informational and due diligence support purposes only.',
            disclaimerText2: 'This certification does not replace mandatory regulatory declarations, field audits, or official government certifications. The issuing organization accepts no liability for decisions made based solely on this document. Users are advised to conduct independent verifications and consult with qualified professionals for regulatory compliance matters.',
        },
    },
    validation: {
        title: 'EUDR Compliance Validation',
        description: 'Technical validation based on EU Regulation 2023/1115 and FAO forest definitions',
        errorValidating: 'Error validating polygon',
        validatingPolygon: 'Validating polygon...',
        validationError: 'Validation Error',
        checksPassed: 'checks passed',
        tabs: {
            topology: 'Topology',
            geometry: 'Geometry',
            baseline: 'Baseline State',
            thresholds: 'FAO Thresholds',
            edge: 'Edge Effects',
        },
        checks: {
            topologyValidation: 'Topology Validation',
            topologyPass: 'No self-intersections, correct closure',
            topologyFail: 'Geometry has topology issues',
            wgs84Compliance: 'WGS84 Compliance',
            wgs84Pass: 'Coordinate Reference System validated',
            wgs84Fail: 'Using {{crs}} instead of WGS84',
            fourHectareRule: '4 Hectare Rule',
            fourHectarePass: 'Polygon mandatory (>4ha)',
            fourHectareFail: 'Point allowed but polygon recommended',
            baselineState: 'Baseline State (Dec 31, 2020)',
            classifiedAs: 'Classified as {{classification}}',
            faoTreeCoverDensity: 'FAO Tree Cover Density',
            threshold: 'threshold',
        },
        topology: {
            title: 'Topology Validation',
            description: 'Ensures polygon geometry meets GIS standards for spatial analysis',
            selfIntersection: 'Self-Intersection',
            noSelfIntersection: 'Polygon does not cross itself',
            closure: 'Closure',
            closureDescription: 'First and last point are identical',
            vertexCount: 'Vertex Count',
            vertexCountDescription: 'Original vertices defining the polygon shape',
            simplifiedVertices: 'Simplified Vertices',
            simplifiedDescription: 'Optimized for API efficiency (<5m precision loss)',
            precisionLoss: 'Precision Loss',
            precisionLossDescription: 'Geometric simplification resulted in {{meters}} meters of maximum displacement. This is well within the acceptable threshold (<5m) for Sentinel-2 analysis at 10-meter resolution.',
        },
        geometry: {
            title: 'Geometry Information',
            description: 'Spatial reference and measurement details',
            crs: 'Coordinate Reference System',
            tracesCompatible: 'Compatible with the EU TRACES system',
        },
        baseline: {
            title: 'Baseline State (December 31, 2020)',
            description: 'Historical land use classification determines EUDR compliance requirements',
            estimatedTitle: 'Estimated Baseline Data',
            estimatedDescription: 'Baseline data is estimated using a biome-based screening model. Verified satellite baseline integration is in progress.',
            classification: 'Classification',
            lockedMessage: 'LOCKED: Any conversion to agriculture is prohibited under EUDR',
            safeMessage: 'SAFE: Pre-existing agricultural land (no deforestation risk)',
            forestCover: 'Forest Cover',
            confidence: 'Confidence',
            referenceDate: 'Reference Date',
            dataSource: 'Data Source',
            logicTitle: 'EUDR Baseline Logic',
            logicForest: 'If State_Initial == FOREST → The polygon is permanently locked. Any future change to agriculture/grazing is considered illegal deforestation.',
            logicAgriculture: 'If State_Initial == AGRICULTURE/GRASSLAND → The polygon is safe for continued agricultural use, provided legal documentation exists.',
        },
        thresholds: {
            title: 'FAO Forest Definition Thresholds',
            description: 'Three simultaneous criteria must be met for forest classification',
            treeCoverDensity: 'Tree Cover Density',
            minimumArea: 'Minimum Area',
            treeHeight: 'Tree Height',
            threshold: 'Threshold',
            currentValue: 'Current Value',
            currentArea: 'Current Area',
            estimatedHeight: 'Estimated Height',
            approxPixels: '≈ 50 contiguous pixels',
            compliant: 'Compliant',
            nonCompliant: 'Non-Compliant',
            heightLimitationTitle: 'Height Measurement Limitation',
            heightLimitationDescription: 'Optical satellites (Sentinel-2) cannot measure height directly. This system uses auxiliary data from GEDI (Global Ecosystem Dynamics Investigation) LiDAR or SAR (Sentinel-1) texture analysis to estimate canopy height. For critical validations, field verification is recommended.',
        },
        edge: {
            title: 'Edge Effects Correction',
            description: 'Buffer analysis to avoid false positives from boundary errors with neighbors',
            recommended: 'Recommended: Core Analysis Mode',
            originalArea: 'Original Area',
            coreArea: 'Core Area (After Buffer)',
            bufferDistance: 'Buffer Distance',
            edgePercentage: 'Edge Percentage',
            visualRepresentation: 'Visual Representation',
            loadingGeometry: 'Loading polygon geometry...',
            whyNegativeBuffer: 'Why Negative Buffer?',
            whyNegativeBufferDescription: 'GPS accuracy is typically ±5-10 meters. If your polygon overlaps 3 meters into your neighbor\'s forest and they cut trees, the satellite will incorrectly alert YOU. Applying a negative buffer (shrinking the polygon inward 5-10m) creates a "safe core zone" that analyzes only the definitive interior of your parcel, avoiding boundary disputes.',
        },
    },
    errorBoundary: {
        title: 'Something went wrong',
        subtitle: 'An unexpected error occurred in the application',
        errorLabel: 'Error',
        stackTrace: 'Stack Trace (click to expand)',
        reloadPage: 'Reload Page',
        goBack: 'Go Back',
        tip: 'Tip',
        tipText: 'If this error persists, try:',
        tipClearCache: 'Clearing the browser cache',
        tipCheckConsole: 'Checking the browser console (F12) for more details',
        tipContactSupport: 'Contacting technical support if the problem continues',
    },
};

i18n.use(initReactI18next).init({
    resources: {
        es: { translation: esTranslations },
        en: { translation: enTranslations },
    },
    lng: 'en', // Default language
    fallbackLng: 'en',
    interpolation: {
        escapeValue: false,
    },
});

export default i18n;
